/* eslint-disable @typescript-eslint/array-type */
/* eslint-disable react/jsx-key */
// // Copyright (c) Microsoft. All rights reserved.

// import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
// import React from 'react';
// import { IChatMessage } from '../../../libs/models/ChatMessage';
// import { ChatHistoryItem } from './ChatHistoryItem';

// const useClasses = makeStyles({
//     root: {
//         ...shorthands.gap(tokens.spacingVerticalM),
//         display: 'flex',
//         flexDirection: 'column',
//         maxWidth: '105em',
//         width: '100%',
//         justifySelf: 'center',
//     },
//     item: {
//         display: 'flex',
//         flexDirection: 'column',
//     },
// });

// interface ChatHistoryProps {
//     messages: IChatMessage[];
// }

// export const ChatHistory: React.FC<ChatHistoryProps> = ({ messages }) => {
//     const classes = useClasses();

//     return (
//         <div className={classes.root}>
//             {messages.map((message, index) => (
//                 <ChatHistoryItem key={message.timestamp} message={message} messageIndex={index} />
//             ))}
//         </div>
//     );
// };

import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import React, { useEffect, useRef } from 'react';
import { IChatMessage } from '../../../libs/models/ChatMessage';
import { useAppSelector } from '../../../redux/app/hooks';
import { ChatHistoryItem } from './ChatHistoryItem';

const useClasses = makeStyles({
    root: {
        ...shorthands.gap(tokens.spacingVerticalM),
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '105em',
        width: '100%',
        justifySelf: 'center',
    },
    item: {
        display: 'flex',
        flexDirection: 'column',
    },
    highlightedItem: {
        backgroundColor: '#f0f0f0',
        ...shorthands.transition('opacity', '0.5s', 'ease-out'),
    },
});

interface ChatHistoryProps {
    messages: IChatMessage[];
}

export const ChatHistory: React.FC<ChatHistoryProps> = ({ messages }) => {
    const classes = useClasses();
    const messageRefs = useRef<(HTMLDivElement | null)[]>([]);
    const selectedChatId = useAppSelector((state) => state.conversations.selectedChatInConversation?.id);
    // const [highlightedId, setHighlightedId] = useState<string | null>(null);

    useEffect(() => {
        if (selectedChatId) {
            const index = messages.findIndex((message) => message.id === selectedChatId);
            if (index !== -1 && messageRefs.current[index]) {
                const selectedElement = messageRefs.current[index];
                if (selectedElement) {
                    selectedElement.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
            }
            // setHighlightedId(selectedChatId);
        }
    }, [messages, selectedChatId]);

    return (
        // <div className={classes.root}>
        //     {messages.map((message, index) => (
        //         <div ref={el => messageRefs.current[index] = el} key={message.timestamp}>
        //             <ChatHistoryItem message={message} messageIndex={index} />
        //         </div>s
        //     ))}
        // </div>
        <div className={classes.root}>
            {messages.map((message, index) => (
                <div
                    ref={(el) => (messageRefs.current[index] = el)}
                    // className={message.id === highlightedId ? classes.highlightedItem : ''}
                >
                    <ChatHistoryItem key={message.timestamp} message={message} messageIndex={index} />
                </div>
            ))}
        </div>
    );
};
